import { Box, CircularProgress, Dialog, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useEffect, useRef, useState } from 'react'
import { AchievementAPI } from '../AchievementAPI'
import storeAuth from 'GlobalStores/User/StoreAuth'
import StoreAchievement from '../StoreAchievement'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import { Select } from '@mobiscroll/react'
import { last } from 'lodash'
import { useNavigate, useParams } from 'react-router-dom'
import mobiscroll from '@mobiscroll/react'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'

mobiscroll.settings = {
    theme: 'ios',
    themeVariant: 'light'
}
const group = {
    groupWheel: false,
    header: false
}

const Leg3Hc = observer(({ useHref = true }) => {
    const translate = useTranslate()
    const [loading, setLoading] = useState(false)
    const [customers, setCustomers] = useState([])
    const ref = useRef()
    const navigate = useNavigate()

    const params = useParams()

    const handleFetchLeg3Hc = async () => {
        try {
            const response = await AchievementAPI.getLeg3Hc({
                baId: storeAuth.GetId(),
                period: StoreAchievement.getPeriodWithMonthDigit(),
                rank: StoreAchievement.getSelectedRank(),
                ushopCountryCode: storeCountry.Country3(),
                token: storeAuth.GetToken()
            })
            const temp = []
            response.data.customers.map(item => {
                if (item.customer.href) {
                    let value = item.customer.id.unicity
                    if (useHref) {
                        value = `${item.customer.id.unicity}/${last(item.customer.href.split('/'))}`
                    }

                    let sponsorHref = last(storeAuth.GetCustomerHref().split('/'))

                    if (params.id !== storeAuth.GetId()) {
                        sponsorHref = last(storeAuth.GetCustomerHref().split('/'))
                    }

                    value = `${value}/${sponsorHref}`

                    temp.push({
                        text: item.customer.humanName.fullName,
                        value: value,
                        valueText: item.customer.id.unicity.toString(),
                        html:
                            '<div style="font-size:18px;display: flex;align-items: flex-start; flex-flow: column;line-height: 26px;">' +
                            item.customer.humanName.fullName +
                            ' ' +
                            '[' +
                            item.customer.id.unicity +
                            ']</div>'
                    })
                }
            })
            setCustomers(temp)
            setTimeout(() => {
                ref.current?.instance?.show()
            }, 1000)
        } catch (error) {
            console.error(error)
        } finally {
            setTimeout(() => {
                setLoading(false)
            }, 1200)
        }
    }

    const onSelectItem = event => {
        navigate(`/user/genealogy/${event.value.split('/')[0]}`)
    }

    useEffect(() => {
        if (loading) {
            if (customers.length === 0) {
                handleFetchLeg3Hc()
            } else {
                ref.current?.instance?.show()
                setTimeout(() => {
                    setLoading(false)
                }, 1000)
            }
        }
    }, [loading, customers])

    return (
        <Box onClick={() => setLoading(true)} sx={{ cursor: 'pointer' }}>
            {loading ? (
                <CircularProgress size={20} color="primary" />
            ) : (
                <Typography variant="h6" fontFamily={'Inter'} fontSize={'14px'} fontWeight={400} color="#22AAEC">
                    Leg 3
                </Typography>
            )}
            <Select
                display="center"
                data={customers}
                filter={true}
                group={group}
                multiline={2}
                width={400}
                height={70}
                placeholder="Please Select..."
                touchUi={false}
                ref={ref}
                showInput={false}
                onItemTap={onSelectItem}
                className="success-tracker-leg3"
                filterPlaceholderText={translate('genealogy_modal_search')}
                cssClass="success-tracker-leg3"
            />
        </Box>
    )
})

export default Leg3Hc
